import { render, staticRenderFns } from "./Page404.vue?vue&type=template&id=8a2bc85c&scoped=true&lang=pug"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"
import style0 from "./Page404.vue?vue&type=style&index=0&id=8a2bc85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2bc85c",
  null
  
)

export default component.exports